// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"6b232a08","290":"7de5b3f4","356":"38d92266","930":"f15b8968"}[chunkId] + ".chunk.js";
};